import styles from './ProductCardActions.module.scss';
import PropTypes from 'prop-types';
import SignUpPlanModal from '../ProductCardSignUpModal';
import React, { useState } from 'react';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';
import { Button, Link } from '@wienenergiegithub/ui-next';
import { useTrackModalClick } from '../../hooks/useTrackModalClick';

const ProductCardActions = ({
  existingCustomerUrl,
  id,
  isDiscountActive,
  isGeneralRecommender,
  newCustomerUrl,
  newCustomerUrls,
  productOption,
  registerButton,
  selectedAktionCode,
  title,
  productDetailLink,
}) => {
  const [open, setOpen] = useState(false);
  const orderDialog = useDialogStore({ open, setOpen });

  const voucher = isDiscountActive ? selectedAktionCode : null;

  // Track modal open/close events
  useTrackModalClick({
    open,
    productOption,
    title,
    voucher,
  });

  return (
    <div className={styles.container}>
      {registerButton ? (
        registerButton
      ) : (
        <>
          <DialogDisclosure
            render={<Button isElevated>Tarif anmelden</Button>}
            store={orderDialog}
          />
          <SignUpPlanModal
            dialog={orderDialog}
            existingCustomerUrl={existingCustomerUrl}
            id={id}
            newCustomerUrl={newCustomerUrl}
            newCustomerUrls={newCustomerUrls}
            options={productOption}
            title={title}
            trackEvent="tarifCardEvent"
            voucher={voucher}
          />
        </>
      )}

      <Button
        className={styles.details}
        data-purpose="cta-detail"
        render={
          <Link
            target={isGeneralRecommender ? '_blank' : '_self'}
            to={productDetailLink}
          >
            Zur Tarifdetailseite
          </Link>
        }
        theme="primary"
        variant="link"
      />
    </div>
  );
};

ProductCardActions.propTypes = {
  existingCustomerUrl: PropTypes.string,
  isDiscountActive: PropTypes.bool,
  productOption: PropTypes.shape({
    key: PropTypes.string,
    mixtype: PropTypes.string,
    bindung: PropTypes.string,
    capprice: PropTypes.string,
  }),
  selectedAktionCode: PropTypes.string,
  title: PropTypes.string,
};

export default ProductCardActions;
